import Vue from 'vue';
import Router from 'vue-router';
import Main from '@/components/Main';

Vue.use(Router);

export default new Router({
    routes: [{
        path: '/',
        name: 'In a second',
        component: Main
    }]
});



// WEBPACK FOOTER //
// ./src/router/index.js